<div class="notification-overlay" [class.open]="open">

	<button type="button" class="notification-backdrop" (click)="close()" aria-label="Close notifications"></button>

	<aside class="notification-panel" role="dialog" aria-modal="true" aria-labelledby="notif-title">

		<!-- Header -->
		<div class="px-3 pt-3 pb-2 border-bottom bg-white">
			<div class="d-flex align-items-start justify-content-between mb-3">
				<div>
					<h2 id="notif-title" class="fw-bold mb-1" style="font-size:24px;color:#0f172a;">Notifications</h2>
					<p class="mb-0 text-muted" style="font-size:13px;">
						{{ notifications.length }} total &bull; {{ unreadCount }} unread
					</p>
				</div>
				<button type="button"
					class="notif-close-btn btn border-0 rounded-circle d-flex align-items-center justify-content-center"
					(click)="close()" aria-label="Close">
					<i class="fa-solid fa-xmark"></i>
				</button>
			</div>

			<!-- Tabs -->
			<div class="d-flex gap-2 p-1 rounded-3" style="background:#f1f5f9;">
				<button type="button"
					class="notif-tab btn btn-sm flex-fill rounded-2 fw-semibold border-0 d-flex align-items-center justify-content-center gap-1"
					[class.active]="activeTab === 'all'" (click)="setTab('all')">
					All
					<span class="notif-tab-badge" [class.notif-tab-badge--active]="activeTab === 'all'">
						{{ notifications.length }}
					</span>
				</button>
				<button type="button"
					class="notif-tab btn btn-sm flex-fill rounded-2 fw-semibold border-0 d-flex align-items-center justify-content-center gap-1"
					[class.active]="activeTab === 'read'" (click)="setTab('read')">
					Read
					<span class="notif-tab-badge" [class.notif-tab-badge--active]="activeTab === 'read'">
						{{ readCount }}
					</span>
				</button>
				<button type="button"
					class="notif-tab btn btn-sm flex-fill rounded-2 fw-semibold border-0 d-flex align-items-center justify-content-center gap-1"
					[class.active]="activeTab === 'unread'" (click)="setTab('unread')">
					Unread
					<span class="notif-tab-badge notif-tab-badge--unread"
						[class.notif-tab-badge--active]="activeTab === 'unread'">
						{{ unreadCount }}
					</span>
				</button>

			</div>
		</div>

		<div class="px-3 py-2 border-bottom bg-white">
			<div class="d-flex align-items-center gap-2">
				<div class="notif-search-wrap flex-grow-1 position-relative">
					<i class="fa-solid fa-magnifying-glass notif-search-icon text-secondary"></i>

					<input type="text" #searchInput
						class="notif-search-input form-control form-control-sm rounded-3 border-0"
						placeholder="Search notifications..." (input)="onSearch(searchInput.value)" />
				</div>

				<button type="button"
					class="notif-tab btn btn-sm rounded-2 fw-semibold border-0 d-flex align-items-center gap-1 flex-shrink-0"
					(click)="setTab('readAll')">

					Read All

					<span class="notif-tab-badge notif-tab-badge--unread" *ngIf="unreadCount > 0">

						{{ unreadCount }}

					</span>
				</button>

			</div>
		</div>

		<!-- List -->
		<div class="notif-content p-3" (scroll)="loadMore($event)">

			<!-- Empty state -->
			<div *ngIf="filteredNotifications.length === 0"
				class="d-flex flex-column align-items-center justify-content-center text-center py-5"
				style="min-height:260px;">
				<div class="notif-empty-icon rounded-3 d-flex align-items-center justify-content-center mb-3">
					<i class="fa-regular fa-bell-slash fs-4"></i>
				</div>
				<h5 class="fw-bold mb-1" style="color:#0f172a;">No notifications yet</h5>
				<p class="text-muted mb-0" style="font-size:13px;max-width:230px;">
					New alerts will appear here as soon as they arrive.
				</p>
			</div>

			<!-- TODAY -->
			<section class="mb-4" *ngIf="todayNotifications.length > 0">
				<div class="d-flex align-items-center justify-content-between mb-2 px-1">
					<div class="notif-section-label">Today</div>



				</div>

				<div class="d-flex flex-column gap-2">
					<div class="notif-item bg-white border rounded-3 p-3"
						*ngFor="let notif of todayNotifications; trackBy: trackByNotificationId"
						[class.notif-unread]="!notif.isRead" (click)="markAsRead(notif, $event)">

						<div class="notif-row">
							<!-- Icon -->
							<div class="notif-icon shrink-0 rounded-3 d-flex align-items-center justify-content-center text-white"
								[ngClass]="getIconTone(notif)">
								<i class="fa-solid" [ngClass]="getIconClass(notif)"></i>
							</div>

							<!-- Body -->
							<div class="notif-body">
								<div class="notif-title-row">
									<span class="notif-title">{{ notif.title }}</span>
									<div class="notif-meta">
										<span class="notif-time">{{ formattedDateTime(notif) }}</span>
										<span *ngIf="!notif.isRead" class="notif-dot"></span>
									</div>
								</div>
								<!-- <p class="notif-item-msg mb-0">{{ notif.message }}</p> -->
								<p class="notif-item-msg mb-0"
									[class.notif-item-msg--expanded]="expandedIds.has(notif.id)">
									{{ notif.message }}
								</p>
								<button *ngIf="isLongMessage(notif.message)" type="button" class="notif-read-more"
									(click)="toggleExpand(notif.id, $event)">
									{{ expandedIds.has(notif.id) ? 'Show less' : 'Read more' }}
								</button>
							</div>
						</div>

					</div>
				</div>
			</section>

			<!-- OLDER -->
			<section class="mb-2" *ngIf="olderNotifications.length > 0">
				<div class="notif-section-label mb-2 px-1">Older</div>
				<div class="d-flex flex-column gap-2">
					<div class="notif-item bg-white border rounded-3 p-3"
						*ngFor="let notif of olderNotifications; trackBy: trackByNotificationId"
						[class.notif-unread]="!notif.isRead" (click)="markAsRead(notif, $event)">

						<div class="notif-row">
							<!-- Icon -->
							<div class="notif-icon shrink-0 rounded-3 d-flex align-items-center justify-content-center text-white"
								[ngClass]="getIconTone(notif)">
								<i class="fa-solid" [ngClass]="getIconClass(notif)"></i>
							</div>

							<!-- Body -->
							<div class="notif-body">
								<div class="notif-title-row">
									<span class="notif-title">{{ notif.title }}</span>
									<div class="notif-meta">
										<span class="notif-time">{{ formattedDateTime(notif) }}</span>
										<span *ngIf="!notif.isRead" class="notif-dot"></span>
									</div>
								</div>
								<p class="notif-item-msg mb-0">{{ notif.message }}</p>
							</div>
						</div>

					</div>
				</div>
			</section>

		</div>
	</aside>
</div>